export default [{
    path: '/admin/merchant/settings',
    name: 'MerchantSettings',
    component: () => import('@/views/merchant/settings'),
    meta: {
      title: '基本设置'
    }
  },
  {
    path: '/admin/merchant/list',
    name: 'MerchantList',
    component: () => import('@/views/merchant/list'),
    meta: {
      title: '商户列表'
    }
  },
  {
    path: '/admin/merchant/dtl',
    name: 'MerchantDtl',
    component: () => import('@/views/merchant/dtl'),
    meta: {
      title: '店铺详情'
    }
  },
  {
    path: '/admin/merchant/audit',
    name: 'MerchantAudit',
    component: () => import('@/views/merchant/audit'),
    meta: {
      title: '入驻审核'
    }
  },
  {
    path: '/admin/merchant/audit_center',
    name: 'MerchantAuditCenter',
    component: () => import('@/views/merchant/audit_center'),
    meta: {
      title: '审核中心'
    }
  },
  {
    path: '/admin/merchant/withdraw',
    name: 'MerchantWithdraw',
    component: () => import('@/views/merchant/withdraw'),
    meta: {
      title: '商户提现'
    }
  },
  {
    path: '/admin/merchant/grade',
    name: 'MerchantGrade',
    component: () => import('@/views/merchant/grade'),
    meta: {
      title: '诚信等级'
    }
  },
  {
    path: '/admin/merchant/add_store',
    name: 'MerchantAddStore',
    component: () => import('@/views/merchant/add_store'),
    meta: {
      title: '新增商户'
    }
  },
  {
    path: '/admin/merchant/approve',
    name: 'merchantApprove',
    component: () => import('@/views/merchant/approve_centre/approve'),
    meta: {
      title: '商户-认证表单'
    }
  },
  {
    path: '/admin/merchant/approve_edit',
    name: 'merchantApproveEdit',
    component: () => import('@/views/merchant/approve_centre/approve_edit'),
    meta: {
      title: '商户-认证表单编辑'
    }
  },
  {
    path: '/admin/merchant/approve/list',
    name: 'merchantApproveList',
    component: () => import('@/views/merchant/approve_centre/list'),
    meta: {
      title: '商户-认证列表'
    }
  },
  {
    path: '/admin/merchant/approve/order',
    name: 'merchantApproveOrder',
    component: () => import('@/views/merchant/approve_centre/order'),
    meta: {
      title: '商户-认证订单'
    }
  },
  {
    path: '/admin/merchant/margin/grade',
    name: 'merchantMarginGrade',
    component: () => import('@/views/merchant/margin/grade'),
    meta: {
      title: '商户-保证金-等级'
    }
  },
  {
    path: '/admin/merchant/margin/grade_edit',
    name: 'merchantMarginGradeEdit',
    component: () => import('@/views/merchant/margin/grade_edit'),
    meta: {
      title: '商户-保证金-等级新增/编辑'
    }
  },
  {
    path: '/admin/merchant/margin/order',
    name: 'merchantMarginOrder',
    component: () => import('@/views/merchant/margin/order'),
    meta: {
      title: '商户-保证金-订单'
    }
  },
  {
    path: '/admin/merchant/margin/bill',
    name: 'merchantMarginBill',
    component: () => import('@/views/merchant/margin/bill'),
    meta: {
      title: '商户-保证金-账单'
    }
  },
  {
    path: '/admin/merchant/margin/sale_order',
    name: 'merchantMarginSaleOrder',
    component: () => import('@/views/merchant/margin/sale_order'),
    meta: {
      title: '商户-保证金-售后订单'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/merchant.js